import { Children, cloneElement } from 'react';
import withDropdown from 'components/UIKit/decorators/dropdown';
import styles from 'style/mixins';
import { Row, Column } from 'components/UIKit/Flex';
import { FaCaretDown as DownCaretIcon } from 'react-icons/fa';

const Dropdown = ({
  style,
  selected,
  active,
  setActive,
  mouseDownHandler,
  mouseUpHandler,
  children,
  ...props
}) => (
  <div
    onClick={() => setActive(true)}
    style={{
      position: 'relative',
      ...style,
    }}
    {...props}
    >
    <Row style={styles.dropdownButton}>
      <span style={{ overflow: 'hidden' }}>{selected}</span>
      <DownCaretIcon style={{ marginLeft: 'auto' }} />
    </Row>

    {active && (
      <Column
        style={styles.dropdown}
        onMouseDown={mouseDownHandler}
        onMouseUp={mouseUpHandler}
        onClick={() => setTimeout(() => setActive(false))}
        >
        {Children.map(children, child => (
          <Row className="dropdown-item">
            {cloneElement(child, {
              ...child.props,
              style: {
                ...child.props.style,
                ...styles.dropdownLink,
              },
            })}
          </Row>
        ))}
      </Column>
    )}
  </div>
);

export default withDropdown(Dropdown);
